import React, {useState} from "react";



function ContenedorFiltrosGlobal({cualBusqueda}) {

    const [mostrarFiltroPrincipal, setMostrarFiltroPrincipal] = useState(true);
   
    const [input, setInput] = useState({
        busqueda: "",
        cualFiltro: "",
        contenidoFiltro: ""
    });

    function handleChange(event) {
        const { name, value } = event.target;
        // Permite letras, números y espacios
        const filteredValue = value.replace(/[^A-Za-z0-9\s]/g, '');
        setInput(prevInput => ({ ...prevInput, [name]: filteredValue }));
    }

    function buscar(event) {
        if (input.busqueda.length < 3) {
            alert("Debes escribir al menos 3 caracteres para buscar.");
            return;
        } 
        // Lógica de búsqueda
        cualBusqueda({ ...input, tipo: "busqueda" });
    }

    function filtrar(event) {
        // Lógica de filtrado
       
        cualBusqueda({ ...input, tipo: "filtro" });
    }



    return (
    <div className="d-flex align-items-center w-100">
        {/* Búsqueda */}
        <form className="d-flex me-2 w-100">
            {/* Input */}
            <div className="form-floating me-2 inputBusquedaHome">
                <input 
                    onChange={handleChange}
                    value={input.busqueda}
                    name="busqueda"
                    type="text"
                    className="form-control"
                    id="floatingInput"
                    placeholder="buscar"
                    pattern="[A-Za-z0-9\s]*"
                />
                <label htmlFor="floatingInput">Buscar</label>
            </div>
            {/* botón */}
            <button 
                type="submit" 
                className="btn btn-primary" 
                onClick={(event) => {
                    event.preventDefault();
                    const datosAdicionales = {
                        tipo: "busqueda",
                        busqueda: input.busqueda,
                        deporteSeleccionado: ""
                    };
                    buscar(datosAdicionales);
                }}
            >
                <i className="bi bi-search"></i>
            </button>
        </form>
    </div>       
    );
}





export default ContenedorFiltrosGlobal;